/** Document at businesses/{businessId}/billingProducts/{productId}. */
export interface BillingProduct {
  id: string;
  name: string;
  /** Pesos. */
  price: number;
  /** When false, a factura must use this price. */
  priceEditable: boolean;
}

const MAX_NAME = 120;
const MAX_PRICE = 10_000_000;

export function roundMoney(value: number): number {
  return Math.round(value * 100) / 100;
}

export function formatMoney(amount: number): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(roundMoney(amount));
}

export function parseProductPrice(raw: string | number): number | null {
  const value = typeof raw === 'number' ? raw : Number(String(raw).trim().replace(',', '.'));
  if (!Number.isFinite(value) || value < 0 || value > MAX_PRICE) {
    return null;
  }
  return roundMoney(value);
}

export function normalizeProductName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').slice(0, MAX_NAME);
}
